import { renderInDocument } from '@spotahome/soyuz/client';

import SearchPage from './main';

// Styles
import '../../common/scss/init.scss';

renderInDocument(SearchPage);
